import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import classes from './styles.module.css';

function Status({ currentStatus, setCurrentStatus, isDisabled }) {
    const [isOpened, setIsOpened] = useState(false);

    const status = {
        id: currentStatus,
        name: null,
        color: null,
    };

    switch (currentStatus) {
        case -1:
            status.name = <FormattedMessage id="AccountEditing.status.blocked" defaultMessage="Заблокирован" />;
            status.color = 'rgb(220, 57, 18)';
            break;
        case 1:
            status.name = <FormattedMessage id="AccountEditing.status.active" defaultMessage="Активен" />;
            status.color = 'rgb(16, 150, 24)';
            break;
        default:
            status.name = <FormattedMessage id="AccountEditing.status.active" defaultMessage="Активен" />;
            status.color = 'rgb(16, 150, 24)';
    }

    const statusWrap = useRef(null);
    const statusSelect = useRef(null);

    function onStatusClick() {
        setIsOpened(!isOpened);
    }

    function onselectStatus(id) {
        setCurrentStatus(id);
    }

    function handleClickOutside(e) {
        if (!!statusWrap.current && !statusWrap.current.contains(e.target)) {
            setIsOpened(false);
        } else if (!!statusSelect.current && !!statusSelect.current.contains(e.target)) {
            setIsOpened(false);
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, false);
    }, []);

    return (
        <div ref={statusWrap} className={classes.Status}>
            <div
                onClick={() => {
                    !isDisabled && onStatusClick();
                }}
                className={classes.CurrentStatus}
                style={{ backgroundColor: status.color }}
            >
                {status.name}
            </div>

            {isOpened && (
                <ul ref={statusSelect} className={classes.StatusSelect}>
                    <li style={status.id === 1 ? { fontWeight: 'bold' } : null} onClick={() => onselectStatus(1)}>
                        <FormattedMessage id="AccountEditing.status.active" defaultMessage="Активен" />
                    </li>
                    <li style={status.id === -1 ? { fontWeight: 'bold' } : null} onClick={() => onselectStatus(-1)}>
                        <FormattedMessage id="AccountEditing.status.blocked" defaultMessage="Заблокирован" />
                    </li>
                </ul>
            )}
        </div>
    );
}

export default Status;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectEditing/Status.js